import getConfig from 'next/config'

import { CartSettings, InjectedCartProps, withCart as withCartFactory } from '@grandvisionhq/next'

import { featureToggles } from '../../configuration/feature-toggles'
import { deliveryResolverFactory } from '../../util/delivery-resolver-factory'

const { isBynderImagesEnabled } = featureToggles

const { publicRuntimeConfig } = getConfig()
const staticsUrl = publicRuntimeConfig.grandvision.staticsUrl

export const settings: CartSettings = {
  maximumQuantity: 10,
  isDiscountCodeEnabled: true,
  showCartDiscountDescriptions: true,
  showCartDiscountOnLineItem: false,
  showShippingMethod: true,
  showSubTotal: true,
  showTotalDiscount: true,
  multiDiscountType: true,
  staticsUrl,
  deliveryResolverFactory,
  hideStockAndDeliveryOnLineItem: true,
  isBynderImagesEnabled,
}

export type { InjectedCartProps }

export const withCart = withCartFactory(settings)
